import React, { useState } from 'react';
import ReactDatePicker from "react-datepicker";
import Loader from "react-spinner-loader";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import OpenLayerSource from './OpenLayerSource';
import "react-datepicker/dist/react-datepicker.css";
import './RTIncidentDashboard.css';

const RTIncidentDashboard = () => {
  const handle = useFullScreenHandle();

  const [loader, setLoader] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [error, setError] = useState(null);
  const [selectedYear, setSelectedYear] = useState(2026);

  const [internalFromDate, setInternalFromDate] = useState(new Date(2026, 0, 1));
  const [internalToDate, setInternalToDate] = useState(new Date());
  const [appliedFromDate, setAppliedFromDate] = useState(new Date(2026, 0, 1));
  const [appliedToDate, setAppliedToDate] = useState(new Date());

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value);
    setSelectedYear(year);
    const today = new Date();
    const newFrom = new Date(year, 0, 1);
    const yearEnd = new Date(year, 11, 31);
    const nextTo = today <= yearEnd ? today : yearEnd;
    setInternalFromDate(newFrom);
    setInternalToDate(nextTo);
    setAppliedFromDate(newFrom);
    setAppliedToDate(nextTo);
  };

  const handleApply = () => {
    if (!internalFromDate || !internalToDate) {
      setError("Please select both From and To dates");
      return;
    }
    if (internalFromDate > internalToDate) {
      setError("From date cannot be greater than To date");
      return;
    }
    setError(null);
    setAppliedFromDate(internalFromDate);
    setAppliedToDate(internalToDate);
  };

  const isApplyDisabled = !!error || !internalFromDate || !internalToDate;

  const toggleFullscreen = () => {
    isFullscreen ? handle.exit() : handle.enter();
    setIsFullscreen(!isFullscreen);
  };

  return (
    <FullScreen handle={handle}>
      <div className={`rid-root${isFullscreen ? " rid-fs" : ""}`}>
        <Loader show={loader} type="body" stack="vertical" message="Loading Data" />

        {/* ── NAV (Avalanche-style) ── */}
        <nav className="rid-nav">
          <div className="rid-nav-brand">
            <div className="rid-nav-logo">
              <svg viewBox="0 0 20 20" fill="none" width="16" height="16">
                <path d="M10 2l8 6v10H2V8l8-6z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity=".9"/>
                <circle cx="10" cy="11" r="2.5" stroke="white" strokeWidth="1.5" opacity=".9"/>
              </svg>
            </div>
            <div className="rid-nav-title">Incident Dashboard</div>
          </div>

        

            <button className="rid-btn-icon" onClick={toggleFullscreen}>
              {isFullscreen ? (
                <svg viewBox="0 0 18 18" fill="none" width="14" height="14">
                  <path d="M2 6H6V2M16 6H12V2M2 12H6V16M16 12H12V16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                </svg>
              ) : (
                <svg viewBox="0 0 18 18" fill="none" width="14" height="14">
                  <path d="M2 6V2h4M12 2h4v4M2 12v4h4M16 12v4h-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                </svg>
              )}
            </button>
        
        </nav>

        {error && (
          <div className="rid-error-strip">
            <svg viewBox="0 0 16 16" fill="none" width="13" height="13">
              <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.4"/>
              <path d="M8 5v3.5M8 10.5v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            {error}
          </div>
        )}

        {/* ── MAP CONTENT ── */}
        <div className="rid-content">
          <OpenLayerSource
            fromDate={appliedFromDate}
            toDate={appliedToDate}
          />
        </div>
      </div>
    </FullScreen>
  );
}

export default RTIncidentDashboard;